<template>
  <b-row class="overflow-auto pt-3">
    <b-col>
      <b-row>
        <b-col>
          <p>
            {{rows}} results found at
            this location
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-list-group id="my-table" class="mb-2">
            <b-list-group-item
              class="p-0"
              v-for="item in filtItems"
              :key="item.reference_designator"
              button
            >
              <div
                class="flex-column align-items-start p-2"
                v-if="item.source == 'infrastructures' || item.source === 'infra-checkboxes'"
                @click="selectInfra(item.reference_designator)"
              >
                <div class="d-flex w-100">
                  <h6 class="infra-title">
                    <!--Infra icons in separate component displayed on infra popup in map-->
                    <infra-icons :infraAT="item.asset_type"></infra-icons>
                    <strong style="vertical-align: super">{{ item.name }}</strong>
                    <b-badge
                      id="discontinued-badge"
                      v-if="item.discontinued"
                      pill
                      variant="secondary"
                    >Discontinued</b-badge>
                  </h6>
                </div>
                <div>
                <small>
                  {{item.reference_designator}} | Infrastructure | {{item.seafloor_depth_m}} m
                </small>
                </div>
                <div>
                  <infra-indicator
                    :infraRD="item.reference_designator"
                  ></infra-indicator>
                </div>
              </div>
              <div
                class="flex-column align-items-start p-2"
                v-if="item.source == 'instrumentsSource' || item.source === 'inst-checkboxes'"
                :id="`inst-container-${item.reference_designator}`"
                style="cursor: default;"
                @click="selectInst(item.reference_designator)"
              >
                <div class="d-flex w-100">
                  <h5 class="instrument-title">
                    <!-- Substituting icon img for status indicator -->
                    <!--Inst icons in separate component-->
                    <inst-icons :instAT="getInstrumentImg(`${item.asset_type}`)"></inst-icons>
                    <strong style="vertical-align: middle">{{ item.instrument_name }}</strong>
                    <b-badge
                      id="discontinued-badge"
                      v-if="item.discontinued"
                      pill
                      variant="secondary"
                    >Discontinued</b-badge>
                  </h5>
                </div>
                <div>
                  <small>
                    {{item.reference_designator}} | Instrument | {{item.seafloor_depth_m}} m
                  </small>
                </div>
                <div>
                  <!--Status indicator icon using nereus information-->
                  <!--Uses a btn instead of a badge-->
                  <status-indicator
                    :instRD="item.reference_designator"
                  ></status-indicator>
                </div>
                <b-popover
                  :target="`inst-container-${item.reference_designator}`"
                  :ref="`popover-${item.reference_designator}`"
                  placement="right"
                  triggers="hover"
                  boundary="viewport"
                  no-fade
                >
                  <instruments-popup
                    :feature="item"
                    :daModal="daModal"
                    :ooiURL="ooiURL"
                  ></instruments-popup>
                </b-popover>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            v-if="rows > perPage"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import InstrumentsPopupVue from '../InstrumentsPopup';
import StatusIndicatorVue from '../../statusIndicators/StatusIndicatorMulti';
import InfraIndicatorVue from '../../statusIndicators/InfraStatusIndicatorMulti';
import InfraIcons from '../infraIcons';
import InstIcons from '../instIcons';

export default {
  props: ['features', 'daModal', 'ooiURL'],
  data() {
    return {
      perPage: 3,
      currentPage: 1,
      filtItems: [],
      currentInst: null,
    };
  },
  components: {
    'instruments-popup': InstrumentsPopupVue,
    'status-indicator': StatusIndicatorVue,
    'infra-indicator': InfraIndicatorVue,
    'infra-icons': InfraIcons,
    'inst-icons': InstIcons,
  },
  mounted() {
    if (this.rows > this.perPage) {
      this.filterItems();
    } else {
      this.filtItems = this.allitems;
    }
  },
  methods: {
    ...mapActions([
      'mapSelectInfrastructure',
      'getInfraWPContent',
      'setInfraDetailsContent',
      'toggleSidebar',
      'determineSidebarContent',
    ]),
    selectInst(refDes) {
      this.currentInst = refDes;
      const buttonId = `inst-container-${this.currentInst}`;
      this.$root.$emit('bv::hide::popover');
      this.$root.$emit('bv::show::popover', buttonId);
    },
    selectInfra(refDes) {
      const selectedFeature = _.find(this.features, [
        'properties.reference_designator',
        refDes,
      ]);
      this.clearSelections();
      this.mapSelectInfrastructure({ infrastructure: selectedFeature });
      this.getInfraWPContent();
      this.determineSidebarContent({ sidebarContent: 'infra-details' });
      this.toggleSidebar({ showSidebar: true });
    },
    clearSelections() {
      this.mapSelectInfrastructure({ infrastructure: null });
      this.setInfraDetailsContent({ wpContent: null });
    },
    filterItems() {
      const indexStart = (this.currentPage - 1) * this.perPage;
      const indexEnd = this.perPage * this.currentPage;
      this.filtItems = this.allitems.slice(indexStart, indexEnd);
    },
    showDAModal(rd, instrumentTitle) {
      this.daModal.show(rd, instrumentTitle);
    },
    getInstrumentImg(val) {
      const instAsset = val.replace('-wht', '');
      return instAsset;
    },
  },
  computed: {
    ...mapState({
      map: (state) => state.webmap,
    }),
    allitems() {
      return this.features.map((feat) => feat.properties);
    },
    rows() {
      return this.allitems.length;
    },
  },
  watch: {
    currentPage() {
      this.filterItems();
    },
  },
};
</script>

<style>
.instrument-title .infra-title {
  font-size: 1rem;
  margin-bottom: unset;
}
</style>
